export enum FilterValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
    serviceId = 'serviceId',
    states = 'states',
    companyId = 'companyId',
    travelAgencyId = 'travelAgencyId',
}
